
import { Skeleton } from '@/components/ui/skeleton';
import Table from '@/components/ui/table';
import { ColumnType } from '@/Types/global';
import { authState } from '@/vars/auth';
import { useQuery, useReactiveVar } from '@apollo/client';
import dayjs from 'dayjs';
import { toNumber } from 'lodash';

import ListHeader from '@/components/common/Header/ListHeader';
import StatusBadge from '@/components/common/StatusBadge/StatusBadge';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { PaymentStatus } from '@/Types/gql/graphql';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { GET_TRAINER_PAYMENT } from './GraphQL/queries';


const PaymentDetails = () => {

  const [filterValues, setFilterValues] = useState<{
    [key: string]: string | number | undefined;
  }>({
    page: 0,
  });


  const { userDetails } = useReactiveVar(authState);

  const { id } = useParams();



  const {
    data,
    loading,

  } = useQuery(GET_TRAINER_PAYMENT, {
    variables: {
      filter: {

        transactionId: id
      },
      search: '',
      limit: 10,
      offset: Math.max(+(filterValues?.['page'] || 0) - 1, 0) * 10,
      sort: {
        sessionStartTime: -1,
      },
      getAllTrainerpaymentCountFilter2: {
        transactionId: id
      }
    },
    fetchPolicy: 'network-only',
  });



  const Columns: ColumnType[] = [
    { title: 'Session ID ', id: 'session', isVisible: true },
    { title: 'Name', id: 'name', isVisible: true },
    { title: 'Training Program', id: 'training', isVisible: true },
    { title: 'Schedule', id: 'schedule', isVisible: true, },
    { title: 'Status', id: 'status', isVisible: true, },

  ];



  const sessionCount = data?.getAllTrainerpaymentCount;

  const tableData =
    data &&
    data?.getAllTrainerpayment &&
    data?.getAllTrainerpayment?.length > 0 &&
    data?.getAllTrainerpayment?.map((row) => ({
      // onClick: () => handleNavigate(row?._id || ''),
      cells: {
        session: row?.sessionUniqId,
        name: (
          <div className='flex items-center gap-3'>
            <Avatar className='w-8 h-8 bg-[#515764]'>
              {loading ? (
                <Skeleton className='w-8 h-8' />
              ) : (
                <>
                  <AvatarImage
                    src={row?.traineeIdUser?.profileImage || ''}
                    alt='Profile picture'
                    className='object-cover'
                  />
                  <AvatarFallback className='text-base font-bold'>
                    {(row?.traineeIdUser?.firstName?.charAt(0) || '') +
                      (row?.traineeIdUser?.lastName?.charAt(0) || '')}
                  </AvatarFallback>
                </>
              )}
            </Avatar>
            <span className='text-base font-medium'>
              {`${row?.traineeIdUser?.firstName || ''} ${row?.traineeIdUser?.lastName || ''}`}
            </span>
          </div>
        ),
        training: row?.programDetails?.programName === 'FitPrime' ? row?.programDetails?.programName + `(${row?.trainingType?.title})` : row?.programDetails?.programName ?? '',
        schedule: (
          <div>
            <div>
              {row?.sessionStartTime ? dayjs(row.sessionStartTime).format('MM/DD/YYYY') : 'N/A'}
            </div>
            {row?.sessionStartTime
              ? `${dayjs(row.sessionStartTime).format('hh:mm a')} - ${row.sessionEndTime ? dayjs(row.sessionEndTime).format('hh:mm a') : 'N/A'}`
              : 'N/A'}
          </div>
        ),
        status: <StatusBadge
          status={
            row?.status == 'PAID'
              ? 'Completed'
              : row?.status == PaymentStatus.Failed
                ? 'Canceled'
                : row?.status == PaymentStatus.Canceled
                  ? 'No-Show'
                  : 'Scheduled'
          }
        />,
      },
    }));





  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className='h-full w-full '>
      <ListHeader
        userName={userDetails?.firstName + ' ' + userDetails?.lastName}
        showSearch={false}
        showButton={false}
        filterButton={false}
        payment={false}
        paymentDetailsPage={true}
        transactionId={data?.getAllTrainerpayment?.[0]?.transactionId ?? ''}
        TransactionDate={data?.getAllTrainerpayment?.[0]?.paidOn ?? ''}
        sessionCount={sessionCount ?? 0}
      />
      <div className='flex flex-col align-center '>

        <Table
          id={'paymetdetailtable'}
          noPadding={false}
          loading={loading}
          columns={Columns}
          dataCount={data?.getAllTrainerpaymentCount}
          setFilterValues={setFilterValues}
          filterValues={filterValues}
          data={tableData || []}
          itemsPerPage={10}
          onPageChange={(page) => setFilterValues({ page: page })}
          page={toNumber(filterValues?.page) || 0}
        />
      </div>
    </div>


  );
};

export function LoadingComponent() {
  return (
    <div className='h-full w-full flex'>
      <div className='flex flex-row mt-12 gap-7 mx-auto'>
        <div>
          <LoadingBuyMoreComponent />
        </div>
        <div className='flex flex-col max-w-[90%] w-[1000px]'>
          <Skeleton className='h-7 w-48 mb-2 bg-bgSecondary' />
          <Skeleton className='h-4 w-96 mb-6 bg-bgSecondary' />
          <LoadingTable />
        </div>
      </div>
    </div>
  );
}

function LoadingBuyMoreComponent() {
  return <Skeleton className=' bg-bgSecondary min-w-72 h-64' />;
}

function LoadingTable() {
  return (
    <div className='flex flex-col gap-4'>
      <Skeleton className='h-10  bg-bgSecondary' />
      {[...Array(5)].map((_, index) => (
        <Skeleton key={index} className='h-12 bg-bgSecondary' />
      ))}
    </div>
  );
}

export default PaymentDetails;


